import { useSelector } from 'react-redux'
import { useCallback } from 'react'
import { getHomeTrackingEventSubmitted, setHomeTrackingEventSubmitted } from '../actions/home'
import { ClientEventName, ClientEventSource } from '../api/gqlaxy/gql/generated/graphql'
import { useCreateClientEvent } from './useCreateClientEvent'
import { selectHomeUuid } from '../store/selectors/home'
import { selectAuthedAsClient } from '../store/selectors/auth'

type useCreateHomeClientEventOnceProps = {
  eventName: ClientEventName
  eventSource?: ClientEventSource
  eventProperties?: Record<string, any>
  listingId?: string
}
// use useCreateHomeClientEvent if you want to create the event more than once per session
const useCreateHomeClientEventOnce = ({
  eventName,
  eventSource,
  eventProperties = {},
  listingId
}: useCreateHomeClientEventOnceProps) => {
  const homeId = useSelector(selectHomeUuid)
  const tracked: 'true' | null = getHomeTrackingEventSubmitted(eventSource ? `${eventName}_${eventSource}` : eventName)
  const authedAsCustomer = !useSelector(selectAuthedAsClient)

  const { mutateAsync: createClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })

  return useCallback(() => {
    if (homeId && eventName && !authedAsCustomer && !tracked) {
      const clientEventInput: {
        homeId: string
        eventName: ClientEventName
        eventSource?: ClientEventSource
        properties: Record<string, any>
        listingId?: string
      } = {
        homeId: homeId,
        eventName: eventName,
        properties: eventProperties
      }

      if (listingId) {
        clientEventInput.listingId = listingId
      }

      if (eventSource) {
        clientEventInput.eventSource = eventSource
      }

      createClientEvent({
        clientEventInput: clientEventInput
      })
      setHomeTrackingEventSubmitted(eventSource ? `${eventName}_${eventSource}` : eventName)
    }
  }, [eventName, listingId, homeId, tracked])
}

export default useCreateHomeClientEventOnce
